import React from 'react'
import { getIcon } from '../../Components/Functions'
import NaijaStates from "naija-state-local-government";
import Select from "react-select";

const StateLgaComponent = (props) => {

    const pickLga = React.useRef(null);
    const [state, setState] = React.useState();
    const [lga, setLga] = React.useState()
  return (
      <>
      {props?.readOnly ? <style>
            {`
                .read-only-component {
                    pointer-events: none;
                }
                .read-only-component .css-1s2u09g-control {
                    background-color: #f2f2f2;
                    border-color: hsl(0, 0%, 80%);
                    border-width: 0;
                }
            `}
      </style>: ""}
    <div className={`column is-${props.width || 12} ${props?.readOnly ? "read-only-component" : ""}`}>
        <div className="field" key={`${props?.label}_${props?.address_state}`}>
            <label>State/Province</label>
            <div className="control has-icon">
            <Select
                closeMenuOnSelect={true}
                isClearable={false}
                options={NaijaStates.all().map((e) => {
                    return { value: e.lgas, label: e.state };
                })}
                defaultValue={[{ value: props?.address_state, label: props?.address_state }]}
                onChange={(e) => {
                    setState(e);
                    props?.setState(e.label);
                }}
                readOnly={props?.readOnly}
            />
            </div>
        </div>
    </div>
    {(state || props?.address_state) ? (
    <div className={`column is-${props.width || 12} ${props?.readOnly ? "read-only-component" : ""}`}>
        <div className="field" key={`${props?.label}_${props?.address_lga}`}>
            <label>LGA/City</label>
            <div className="control has-icon">
            <Select
                ref={pickLga}
                closeMenuOnSelect={true}
                isClearable={false}
                options={state?.value?.length > 0  ? state.value.map((e) => {
                    return { value: e, label: e };
                }): []}
                defaultValue={[{ value: props?.address_lga, label: props?.address_lga }]}
                onChange={(e) => {
                    props?.setLga(e.value)
                }}
                readOnly={props?.readOnly}
            />
            </div>
        </div>
    </div>
    ) : null}
    </>
  )
}

export default StateLgaComponent